import { computed, observable } from 'mobx'

let entryIdCounter = 0

/**
 * A state's estimated tax payment in the extension acceptance dialog.
 */
export class StateEstimatedTaxPaymentEntryViewModel {
  readonly id = ++entryIdCounter
  @observable accessor state = ''
  @observable accessor amount = 0

  /**
   * Whether a state was picked.
   */
  @computed
  get isCompleted() {
    return this.state !== ''
  }
}
